import * as React from 'react'

const SvgFileUpload = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" fill="white" />
    <path
      d="M21.6673 11.8914V15.3335C21.6673 15.8002 21.6673 16.0335 21.7581 16.2118C21.838 16.3686 21.9655 16.4961 22.1223 16.576C22.3006 16.6668 22.5339 16.6668 23.0007 16.6668H26.4428M17.5007 22.5001L20.0007 25.0001M20.0007 25.0001L22.5007 22.5001M20.0007 25.0001L20.0007 20.0001M21.6673 11.6667H17.334C15.9339 11.6667 15.2338 11.6667 14.699 11.9392C14.2286 12.1789 13.8462 12.5614 13.6065 13.0318C13.334 13.5666 13.334 14.2666 13.334 15.6667V24.3334C13.334 25.7335 13.334 26.4336 13.6065 26.9684C13.8462 27.4388 14.2286 27.8212 14.699 28.0609C15.2338 28.3334 15.9339 28.3334 17.334 28.3334H22.6673C24.0674 28.3334 24.7675 28.3334 25.3023 28.0609C25.7727 27.8212 26.1552 27.4388 26.3948 26.9684C26.6673 26.4336 26.6673 25.7335 26.6673 24.3334V16.6667L21.6673 11.6667Z"
      stroke="#667085"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" stroke="#D5D9EB" />
  </svg>
)

export default SvgFileUpload
